import { Ref } from '@vue/composition-api';
import {
	AnyHighlightChildRequest,
	ElementType,
	HighlightsContainerRequest,
	HighlightsSectionRequest,
	SectionType,
} from '../model';
import { areSame } from './compare';

export function performDelete(theItem: AnyHighlightChildRequest, container: HighlightsContainerRequest): HighlightsSectionRequest[] {
	const theType: ElementType | SectionType = theItem.type;
	switch (theType) {
	case SectionType.FULL_WIDTH_LIST:
		return container.sections.filter((i) => !areSame(theItem, i));
	case ElementType.HEADING:
	case ElementType.TEXT:
	case ElementType.BUTTON:
	case ElementType.IMAGE:
	case ElementType.SURVEY:
	case ElementType.VIDEO:
		return container.sections.map((section) => ({
			...section,
			elements: section.elements.filter((i) => !areSame(theItem, i)),
		}));
	default:
		// eslint-disable-next-line
		const exhaustiveCheck: never = theType;
		throw new Error(`Unhandled route case: ${exhaustiveCheck}`);
	}
}
